const app = {
  state: {
    appVersion: '0.0.1'
  }
}

export default app
